<template>
  <div>
    <div class="dashboard-title">{{ $t("dashboard.recharge.title") }}</div>
    <hr />
    <div class="recharge-steps" v-if="step == 1">
      <h1 class="color-gold">{{ $t("dashboard.recharge.firstBonus") }}</h1>
      <div class="bonus-cards">
        <div
          class="bonus-card"
          v-for="(bonus, key) in firstBonus"
          :key="key"
          @click="rechargeThis(bonus)"
        >
          <span class="bonus"
            >+{{ bonus.bonus }} {{ $t("dashboard.recharge.bonus") }}</span
          >
          <div class="amount">
            <img src="../../assets/gcoin.png" alt="GCoin" />
            <span>{{ bonus.amount }}</span>
          </div>
          <span class="price">${{ bonus.price }}</span>
        </div>
      </div>
    </div>
    <div class="recharge-steps amount-step" v-if="step == 2">
      <p>{{ $t("dashboard.recharge.amount") }}</p>
      <div class="w-100 d-flex justify-content-between">
        <div class="item">
          <img src="../../assets/gcoin.png" alt="GCoin" />
          <span>{{ chosenRecharge.amount }}</span>
        </div>
        <span class="bonus"
          >+{{ chosenRecharge.bonus }}
          {{ $t("dashboard.recharge.bonusCoins") }}</span
        >
        <span class="price">${{ chosenRecharge.price }}</span>
      </div>
      <div class="w-100 d-flex justify-content-between">
        <span class="item">{{ $t("dashboard.recharge.fee") }}</span>
        <span class="price">${{ chosenRecharge.fee }}</span>
      </div>
      <div class="w-100 d-flex justify-content-between total">
        <span class="item">{{ $t("dashboard.recharge.total") }}</span>
        <span class="price">${{ total }}</span>
      </div>
      <div class="input-group custom-control-input">
        <input
          id="agree"
          type="checkbox"
          name="agree"
          :value="true"
          v-model="agree"
        />
        <label for="agree"
          ><span v-html="$t('dashboard.recharge.agree')"></span
        ></label>
      </div>
      <div class="input-group custom-control-input">
        <input
          id="affirm"
          type="checkbox"
          name="affirm"
          :value="true"
          v-model="affirm"
        />
        <label for="affirm"
          ><span v-html="$t('dashboard.recharge.affirm')"></span
        ></label>
      </div>
      <div class="btn btn-gold text-white btn-pay" @click="payNow">
        {{ $t("dashboard.recharge.pay") }}
      </div>
    </div>
    <div class="recharge-steps" v-if="step == 3">Payment Step</div>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      firstBonus: [],
      step: 1,
      chosenRecharge: {},
      total: 0,
      agree: false,
      affirm: false,
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    getData() {
      // 调用API获取数据
      this.firstBonus = [
        {
          amount: 506,
          price: 4.99,
          bonus: 6,
          fee: 0.0,
        },
        {
          amount: 1015,
          price: 9.99,
          bonus: 32,
          fee: 0.0,
        },
        {
          amount: 2032,
          price: 19.99,
          bonus: 100,
          fee: 0.0,
        },
        {
          amount: 4066,
          price: 39.99,
          bonus: 6,
          fee: 0.0,
        },
        {
          amount: 7086,
          price: 69.99,
          bonus: 15,
          fee: 0.0,
        },
        {
          amount: 10100,
          price: 99.99,
          bonus: 86,
          fee: 0.0,
        },
      ];
    },
    numberWithCommas(x) {
      return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    rechargeThis(bonus) {
      this.step = 2;
      this.chosenRecharge = bonus;
      this.total = this.chosenRecharge.price + this.chosenRecharge.fee;
    },
    payNow() {
      if (!this.agree || !this.affirm) return;
      this.step = 3;
      // 判断是否已链接Stripe
      this.$router.push("link-stripe");
    },
  },
};
</script>

<style>
.recharge-steps {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  margin: 3rem auto;
  max-width: 500px;
  h1 {
    font-size: 2rem;
    margin: 1.5rem auto;
  }
  .bonus-cards {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
    gap: 1rem;
    .bonus-card {
      width: 150px;
      border: 1.3px solid #ef8200;
      border-radius: 10px;
      position: relative;
      overflow: hidden;
      .bonus {
        position: absolute;
        top: 0;
        right: 0;
        background-color: #ef8200;
        color: white;
        font-size: 0.8rem;
        line-height: 1.5rem;
        padding: 0 0.5rem;
      }
      .bonus::before {
        content: "";
        display: block;
        position: absolute;
        left: -23.5999px;
        width: 0;
        height: 0;
        border-top: 1.5rem solid #ef8200;
        border-left: 1.5rem solid transparent;
      }
      .amount {
        margin-top: 2rem;
        width: 100%;
        text-align: center;
        img {
          width: 28px;
          margin-right: 0.25rem;
        }
        span {
          color: #ef8200;
          font-size: 2rem;
          font-weight: 600;
          vertical-align: middle;
        }
      }
      .price {
        color: #687b8e;
        margin: 0 auto;
        display: block;
        text-align: center;
      }
    }
  }
}
.amount-step {
  align-items: flex-start;
  .item {
    color: #3b3e51;
    font-size: 1.15rem;
    font-weight: 500;
    line-height: 2.5rem;
    img {
      width: 28px;
    }
    span {
      vertical-align: middle;
    }
  }
  .bonus {
    color: #ff7b00;
    font-size: 1.5rem;
  }
  .price {
    color: #687b8e;
    font-size: 1.5rem;
  }
  .total {
    background-color: #e4fffb;
    padding: 1rem;
    margin: 1rem 0;
    .item {
      font-size: 1rem;
      font-weight: 400;
    }
    .price {
      color: #3b3e51;
      font-weight: 600;
    }
  }
  .custom-control-input {
    width: 100%;
    font-size: 1rem;
    line-height: 2rem;
    input[type="checkbox"] {
      display: none;
    }
    label {
      position: relative;
      cursor: pointer;
      padding-left: 1.6rem;
    }
    label::before {
      content: "";
      display: inline-flex;
      justify-content: center;
      align-items: center;
      position: absolute;
      left: 0;
      top: 0.3rem;
      width: 1.3rem;
      height: 1.3rem;
      border-radius: 1.3rem;
      margin-right: 0.5rem;
      background-color: transparent;
      border: 3px solid #ff00004d;
    }
    input[type="checkbox"]:checked + label:before {
      content: "\2713";
      color: white;
      font-size: 0.8rem;
      line-height: 1.3rem;
      background-color: rgb(19, 200, 255);
      border: 3px solid rgb(19, 200, 255);
    }
  }
  .btn-pay {
    align-self: flex-end;
    width: 50%;
    padding: 1rem;
    margin: 1rem 0 3rem;
    font-size: 1.25rem;
    font-weight: 600;
  }
}
</style>
